import { memo, useCallback, useEffect, useState } from "react";
import { AppstoreOutlined, FileOutlined, FileTextOutlined, SearchOutlined, ShopOutlined } from "@ant-design/icons";
import { AutoComplete } from "antd";
import { debounce } from "lodash";
import { useAuthenticatedFetch } from "@/Api/Axios";

function SearchAutocomplete(props) {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetch = useAuthenticatedFetch();
  const {
    form: { setFieldTouched },
    field: { name },
  } = props;

  const fetchResults = async (query) => {
    const response = await fetch.get(`searchShopify?query=${query}`, false);
    const results = [];
    props.subtype.map((type) =>
      response.data[type + "s"].map((node) =>
        results.push({
          type: type,
          title: node.title,
          id: node.id,
          label: type.toUpperCase() + " - " + node.title,
          value: node.id,
          handle: node.handle,
          originalSrc: node.featured_image ? node.featured_image.url : node.originalSrc,
          description: node.featured_image ? node.body.replace(/<[^>]*>/g, "") : node.description,
          media: loadMedia(type + "s"),
        })
      )
    );
    return results;
  };

  const loadMedia = (type) => {
    if (type === "products") {
      return <ShopOutlined />;
    }
    if (type === "collections") {
      return <AppstoreOutlined />;
    }
    if (type === "articles") {
      return <FileTextOutlined />;
    }
    if (type === "pages") {
      return <FileOutlined />;
    }
  };

  useEffect(() => {
    setSelectedOptions([props?.value]);
    setInputValue(props?.value?.label || "");
    updateText("");
  }, []);

  const updateText = useCallback(
    async (value) => {
      if (!loading) {
        setLoading(true);
      }

      let result = await fetchResults(value);
      setLoading(false);
      setOptions(result);
    },
    [loading]
  );

  useEffect(() => {
    props.form.setFieldValue(props.field.name, selectedOptions[0]);
  }, [selectedOptions, props.form, props.field.name]);

  const handleSelect = useCallback((selectedValue, option) => {
    setSelectedOptions([option]);
    setInputValue(option.label || "");
  }, []);

  const handleSearch = useCallback((value) => {
    setInputValue(value);
    searchDebounced(value);
  }, []);

  const searchDebounced = useCallback(debounce(updateText, 500), [updateText]);

  return (
    <div>
      <AutoComplete
        value={inputValue}
        options={options.map((option) => ({
          value: option.value,
          label: (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {option.media}
              <span>{option.label}</span>
            </div>
          ),
          ...option,
        }))}
        onSearch={handleSearch}
        onSelect={handleSelect}
        placeholder={props.placeholder}
        disabled={props.disabled}
        suffixIcon={<SearchOutlined />}
        style={{ width: "100%" }}
        onBlur={() => {
          setFieldTouched(name, true);
        }}
        allowClear
        loading={loading}
      />
    </div>
  );
}

export default memo(SearchAutocomplete);
